import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SseService } from 'src/app/services/SseService';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { META_API_ACCOUNT_KEY, MetaApiService } from 'src/app/services/meta-api.service';

export interface MetaApiCuentaGuardada {
  metaApiAccountId: string;
  nombre: string;
  mtLogin: string;
  mtServer: string;
  region: string;
  estado: string;
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  // Datos del usuario
  email: string = '';
  userId: string = '';
  diasRestantes: number = 0;
  userInitials: string = '';

  // Carteras
  carteras: OptimalWallet[] = [];
  loadingCarteras = false;

  // Broker IBKR
  ibkrConectado = false;
  ibkrApiDisponible = false;

  // MetaAPI
  metaApiCuentas: MetaApiCuentaGuardada[] = [];
  loadingMetaApi = false;
  activeMetaApiAccountId: string = '';

  constructor(
    private cookieService: CookieService,
    private sseService: SseService,
    private router: Router,
    private metaApiService: MetaApiService
  ) {}

  ngOnInit(): void {
    this.cargarDatosUsuario();
    this.cargarCarteras();
    this.cargarEstadoIBKR();
    this.cargarCuentasMetaApi();
  }

  private cargarDatosUsuario(): void {
    this.email = this.cookieService.get('username_logged') || '';
    this.userId = this.cookieService.get('userId') || '';
    const diasStr = this.cookieService.get('dias');
    this.diasRestantes = diasStr ? parseInt(diasStr, 10) : 0;

    if (this.email) {
      const localPart = this.email.split('@')[0];
      const parts = localPart.split(/[._-]/);
      this.userInitials = parts
        .map((p: string) => p[0]?.toUpperCase() || '')
        .slice(0, 2)
        .join('');
      if (!this.userInitials) {
        this.userInitials = this.email[0].toUpperCase();
      }
    }
  }

  private cargarCarteras(): void {
    const licencia = this.cookieService.get('auth_token');
    this.loadingCarteras = true;
    this.sseService.apiPostNew('listarcarteras', null, licencia).subscribe({
      next: (data: any) => {
        this.carteras = (data as OptimalWallet[]).filter(c => c.subCarteras === '');
        this.loadingCarteras = false;
      },
      error: () => {
        this.loadingCarteras = false;
      }
    });
  }

  private cargarEstadoIBKR(): void {
    this.ibkrConectado = localStorage.getItem('brokerConectado') === 'true';
    this.ibkrApiDisponible = localStorage.getItem('apiIbkrAvailable') === 'true';
  }

  private cargarCuentasMetaApi(): void {
    const licencia = this.cookieService.get('auth_token');
    this.activeMetaApiAccountId = localStorage.getItem(META_API_ACCOUNT_KEY) || '';
    this.loadingMetaApi = true;
    this.sseService.apiGetWithAuth('metaapi/cuentas-guardadas', licencia).subscribe({
      next: (data: any) => {
        this.metaApiCuentas = data?.cuentas || [];
        this.loadingMetaApi = false;
      },
      error: () => {
        this.loadingMetaApi = false;
      }
    });
  }

  irABroker(): void {
    this.router.navigate(['/broker']);
  }

  activarCuentaMetaApi(cuenta: MetaApiCuentaGuardada): void {
    localStorage.setItem(META_API_ACCOUNT_KEY, cuenta.metaApiAccountId);
    // Through the service so the in-memory base URLs change too, not just localStorage
    this.metaApiService.setRegionUrl(this.metaApiService.resolveRegion(cuenta.metaApiAccountId, cuenta.region));
    this.activeMetaApiAccountId = cuenta.metaApiAccountId;
  }

  getChipClassDias(): string {
    if (this.diasRestantes >= 30) return 'chip-green';
    if (this.diasRestantes >= 7) return 'chip-yellow';
    return 'chip-red';
  }

  getTipoBrokerLabel(cartera: OptimalWallet): string {
    return cartera.tipoBroker || 'VIRTUAL';
  }
}
